const A="/language/default/load-list",L="apiLanguageControl";export{A as API_LANGUAGE_CONTROL_LOAD_LIST_URL,L as API_LANGUAGE_CONTROL_NAME};
